import { Component } from "@angular/core";

@Component({
  selector: "app-careplus-issuance",
  templateUrl: "./careplus-issuance.component.html",
  styleUrls: ["./careplus-issuance.component.css"],
})
export class CareplusIssuanceComponent {}
